const capitalize = (value, separator) =>
  typeof value === 'string' && value.length > 0
    ? value
        .split(separator)
        .map(word => word && word[0].toUpperCase() + word.substr(1))
        .join(' ')
    : null

export default capitalize
